import { useQuery } from "@tanstack/react-query";

export interface SidebarCounts {
  myPendingLeaves: number;
  overdueTasks: number;
  leaveApprovals?: number;
  joinRequests?: number;
  accessRequests?: number;
}

export function useSidebarCounts() {
  const { data, isLoading } = useQuery<SidebarCounts>({
    queryKey: ["/api/sidebar-counts"],
    refetchInterval: 60000,
  });

  return { counts: data, isLoading };
}
